import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as React from "react";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Base, Blockquote, Button, Container, Flex, Heading, Section, Text } from "./ui";
import * as styles from "./ui.css";
import ReactHtmlParser from 'react-html-parser';

const colorsCol = [
  "#FF4A82",
  "#0092D9",
  "#00C7A2",
  "#762BED"
]

const colorsRH = [
  "#383838",
  "#383838",
  "#383838",
  "#383838"
]


const Icon = ({ color = "#0092D9" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39"
      height="33"
      fill="none"
      viewBox="0 0 39 33"
    >
      <path
        fill={color}
        d="M37.24 0l1.604 3.323c-2.98 1.375-5.31 3.055-6.99 5.042-1.604 1.91-2.406 4.163-2.406 6.76 0 1.146.19 2.1.573 2.865.458.764.993 1.451 1.604 2.062a37.767 37.767 0 011.833 1.719c.611.535 1.108 1.222 1.49 2.062.458.764.687 1.757.687 2.98 0 1.68-.649 3.131-1.947 4.354C32.465 32.389 30.86 33 28.875 33c-1.299 0-2.559-.382-3.781-1.146-1.223-.764-2.216-1.91-2.98-3.437-.687-1.528-1.03-3.476-1.03-5.844 0-3.056.687-6.073 2.062-9.052a26.22 26.22 0 015.729-8.136A24.95 24.95 0 0137.24 0zM16.156 0l1.604 3.323c-2.979 1.375-5.309 3.055-6.99 5.042-1.603 1.91-2.405 4.163-2.405 6.76 0 1.146.19 2.1.572 2.865.459.764.994 1.451 1.605 2.062a37.767 37.767 0 011.833 1.719c.611.535 1.108 1.222 1.49 2.062.458.764.687 1.757.687 2.98 0 1.68-.65 3.131-1.948 4.354C11.382 32.389 9.778 33 7.792 33c-1.299 0-2.56-.382-3.782-1.146-1.222-.764-2.215-1.91-2.979-3.437C.344 26.889 0 24.94 0 22.573c0-3.056.688-6.073 2.063-9.052a26.22 26.22 0 015.729-8.136A24.95 24.95 0 0116.156 0z"
      ></path>
    </svg>
  );
}

function Testimonial({ collaborator, index, ...props }) {
  const colors = collaborator ? colorsCol : colorsRH;
  return (
    <a href={props.videoUrl} style={{ textDecoration: 'none' }} target="_blank">
      <Blockquote cx={[collaborator ? styles.blockquoteTestimonialCol : styles.blockquoteTestimonial]} style={{ borderColor: colors[index] }}>
        <div style={{ width: 39 }}>
          <Icon color={colors[index]} />
        </div>
        {(!collaborator) && <Base
          as={GatsbyImage}
          alt={props.avatar.alt}
          cx={[styles.testimonialImage]}
          objectFit={'cover'}
          image={getImage(props.avatar.gatsbyImageData)}
        />}
        <Text variant="caps" cx={[collaborator ? styles.citationFirstLetterCol : styles.citationFirstLetter]}>
          {props.html}
        </Text>
        <Text as="p" variant="testimonialLead">
          {props.source}
        </Text>
        <Text as="p" variant="testimonialSublead">
          {props.sourceBusiness}
        </Text>
      </Blockquote>
    </a>
  )
}

export default function TestimonialList(props) {
  const collaborator = (props.name === 'colaboradores');
  return (
    <Base as='div' cx={[styles.testimonialContainer]}>
      <div style={{ display: 'flex', flexDirection: 'column', marginTop: 40, marginBottom: 25 }}>
        <Text center variant="testimoniallead" style={{ margin: 0 }}>
          {ReactHtmlParser(props.heading)}
        </Text>
      </div>
      <Flex as='div' cx={[collaborator ? styles.testimonialWrapperCol : styles.testimonialWrapper]} gap={0}>
        <Base as="div" cx={[styles.testimonialSpacer]} ></Base>s
        {props.content.map((item, index) => {
          return <Testimonial {...item} index={index} collaborator={collaborator} />
        })}
        <Base as="div" cx={[styles.testimonialSpacer]} ></Base>
      </Flex>
    </Base>
  )
}

export const query = graphql`
  fragment HomepageTestimonialListContent on HomepageTestimonialList {
    id
    kicker
    heading
    name
    background {
      id
      gatsbyImageData
      alt
    }
    content {
      id
      source
      sourceBusiness
      html
      videoUrl
      avatar {
        id
        gatsbyImageData
        alt
      }
    }
  }
`
